import styled from "styled-components";

export const Icon = styled.img`
width: 100%;
`;

export const Title = styled.h1`
font-size: 9vw;
color: #408C32;
text-align: center;
`;

export const Description = styled.p`
font-size: 4vw;
color: #5F5F5F;
font-weight: 500;
text-align: center;
margin-top: 3%;
`;